<template>
  <div class="voice-control" @click="toggleMic">
    <svg xml:space="preserve" :fill="isRecording ? '#CB3506' : '#000000'" viewBox="0 0 470 470">
      <path d="M235 302.3a85.4 85.4 0 0 0 85.4-85.4V85.4a85.4 85.4 0 0 0-170.8 0V217a85.4 85.4 0 0 0 85.4 85.4z" />
      <path
        d="M350.4 136.1v30h15V217c0 71.9-58.5 130.4-130.4 130.4S104.6 288.9 104.6 217v-51h15v-30h-45v81c0 83.4 64 152.1 145.4 159.7V440h-90.4v30h210.8v-30H250v-63.4a160.6 160.6 0 0 0 145.4-159.7V136h-45z"/>
    </svg>
  </div>
</template>

<script setup>
import { ref, onMounted, defineEmits } from 'vue';
import NativeService from '@/services/NativeService';

const emit = defineEmits(['on-done']);

const transcript = ref('');
const isRecording = ref(false);
const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition || window.mozSpeechRecognition || window.msSpeechRecognition;
const sr = new Recognition();

const toggleMic = () => {
  NativeService.ActivateVoice();
  if (isRecording.value) {
    sr.stop();
  } else {
    sr.start();
  }
};

onMounted(() => {
  sr.lang = 'en-US';
  sr.continuous = true;
  sr.interimResults = true;
  sr.onstart = () => {
    isRecording.value = true;
  };
  sr.onend = () => {
    isRecording.value = false;
  };
  sr.onresult = (evt) => {
    // for (let i = 0; i < evt.results.length; i += 1) {
    //   const result = evt.results[i];
    //   console.log('SR Result', result);
    //   // if (result.isFinal) CheckForCommand(result)
    // }
    const t = Array.from(evt.results)
      .map((result) => result[0])
      .map((result) => result.transcript)
      .join('');

    transcript.value = t;
    emit('on-done', transcript.value);
  };
});
</script>

<style lang="sass" scoped>
.voice-control
  width: 28px
  height: 28px
  display: flex
  justify-content: center
  align-items: center
  flex-shrink: 0
  border-radius: 50%
  border: 1px solid #ccc
  svg
    width: 16px
    height: auto
    flex-shrink: 0
</style>
